export default {
  label: {
    notClassifiedLabels: ['No clasificados', 'No clasificado'],
    notShowClassifiedLabel: 'Mostrar no clasificados',
    showClassifiedLabel: 'Ocultar no clasificados',
    noData: 'No hay datos disponibles',
  },
};
